__turbopack_context__.v({
  "copyAction": "Message-module__O5vSWq__copyAction",
  "markdownContent": "Message-module__O5vSWq__markdownContent",
  "messageRow": "Message-module__O5vSWq__messageRow",
  "typingBounce": "Message-module__O5vSWq__typingBounce",
  "typingIndicator": "Message-module__O5vSWq__typingIndicator",
});
